export { default } from './dashboard.vue'
